import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Header, Dropdown, Table, Form, Button, Segment } from 'semantic-ui-react';
import { NFAIDefectData } from '../../app/models/Restoration';
import { useStore } from '../../app/stores/store';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import DynamicTableCSVReport from '../DynamicTable/DynamicTableCSVReport';
import agent from '../../app/api/agent';
import './NFAIDefectReport.css';

const NFAIDefectReport = () => {
  const { PivotStore } = useStore();
  const [reportTypeValue, setReportTypeValue] = useState<string>('Report Type');
  const [tableEnable, SetTableEnable] = useState<boolean>(false);
  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [loadData, setLoadData] = useState<NFAIDefectData[]>([]);
  const [reportType, setReportType] = useState<string>('');
  const reportTypeOptions = [
    { key: 1, text: 'Title Wise', value: 'Title Wise' },
    { key: 2, text: 'Date Wise', value: 'Date Wise' },
  ];
  let reportName = '';
  const currentDate = new Date();
  const [startDate, setStartDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
  const [endDate, setEndDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
  const [location, setLocation] = useState<{selected:string, options:any[]}>({ 
    selected:"", 
    options: [
      { key: '0', text: 'Chennai', value: 'Chennai' },
      { key: '1', text: 'Hyderabad', value: 'Hyderabad' },
    ] 
  });
  const [projectList, setProjectList] = useState<{ key: string; text: string; value: string }[]>([]);
  const [selectedTitles, setSelectedTitles] = useState<string[]>([]); // Changed to array
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProjectList = async () => {
      try {
        setLoading(true);
        const { data: list } = await agent.NFAIRestoTimeSheet.getProjectList();
        const loadProjectList = list.map((item: any) => ({
          key: item.id,
          text: item.name,
          value: item.name,
        }));
        setProjectList(loadProjectList);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error('Error fetching project list:', error);
      }
    };

    fetchProjectList();
  }, [reportTypeValue]);

  const reportTypeAssign = (_: any, data: any) => {
    const selected = reportTypeOptions.find((option) => option.value === data.value);
    if (selected) {
      setReportTypeValue(selected.value);
      setReportType(selected.value);
      if (selected.value === 'Date Wise') {
        setLoadData([]);
        setSelectedTitles([]);
      }
    } else {
      setReportTypeValue('Report Type');
      setReportType('');
      SetTableEnable(false);
      setLoadData([]);
      setSelectedTitles([]);
    }
  };

  const titleBasedDataLoad = async () => {
    try {
      if (!selectedTitles.length) {
        setLoadData([]);
        setTableLoading(false);
        toast.warning('Please select at least one title');
        return;
      }
      setTableLoading(true);
      const response = await agent.NFAI.getReportByTitleCode(selectedTitles);
      setLoadData(response.data);
      SetTableEnable(true);
      setTableLoading(false);
      reportName = 'Defect_Report_' + selectedTitles.join('_');
    } catch (error) {
      console.error('API Error:', error);
      toast.error('Something went wrong. Please try again!');
      SetTableEnable(false);
      setTableLoading(false);
    }
  };

  const dateBasedDataLoad = async () => {
    try {
      setSelectedTitles([]);
      setTableLoading(true);
      const response = await agent.NFAI.getReportByDate(startDate, endDate, location.selected);
      setLoadData(response.data);
      SetTableEnable(true);
      setTableLoading(false);
      reportName = `Defect_Report_From_${startDate}_upto_${endDate}`;
    } catch {
      toast.error('Something went wrong. Please try again!');
      SetTableEnable(false);
      setTableLoading(false);
    }
  };

  const setDate = (data: any, type: string) => {
    try {
      const formatted = moment(data).format('MM-DD-YYYY');
      type === 'start' ? setStartDate(formatted) : setEndDate(formatted);
    } catch {
      toast.error('Error fetching Date');
    }
  };

  return (
    <div className="defect-report-page">
      <Segment className="defect-report-segment">
        <Header as="h2" className="report-header">Defect Report</Header>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h4
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingRight: '20px',
                paddingTop: '10px',
              }}
            >
              Report Type
            </h4>
            <Dropdown
              placeholder="Report Type"
              fluid
              selection
              clearable
              options={reportTypeOptions}
              onChange={reportTypeAssign}
            />
            {reportType === 'Title Wise' ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: '20px',
                    paddingTop: '10px',
                    paddingLeft: '20px',
                  }}
                >
                  Title Codes
                </h4>
                <Dropdown
                  placeholder="Select Title codes"
                  fluid
                  multiple
                  search
                  selection
                  clearable
                  loading={loading}
                  options={projectList}
                  value={selectedTitles}
                  onChange={(_event, data) => setSelectedTitles(data.value as string[])}
                  style={{ minWidth: '300px' }}
                />
                <Button
                  primary
                  onClick={titleBasedDataLoad}
                  disabled={selectedTitles.length === 0}
                  style={{
                    marginLeft: '10px',
                  }}
                >
                  View Report
                </Button>
                {loadData.length !== 0 && (
                  <div style={{marginLeft: '10px'}}>
                    <DynamicTableCSVReport
                      tableData={loadData}
                      tableName={reportName}
                      name='DefectReportNFAI'
                      fileName={`${selectedTitles.join('_')}_DefectReport`}
                    />
                  </div>
                )}
              </div>
            ) : reportType === 'Date Wise' ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <>
                    <h4
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: '20px',
                        paddingTop: '10px',
                      }}
                    >
                      From Date
                    </h4>
                    <DatePicker
                      placeholderText="From Date"
                      value={
                        startDate
                          ? PivotStore.dateFormat(
                              moment(startDate).format('MM-DD-YYYY'),
                            )
                          : ''
                      }
                      className="date-picker-style"
                      showMonthDropdown
                      showYearDropdown
                      locale={'en'}
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={15}
                      maxDate={moment().toDate()}
                      scrollableYearDropdown
                      onChange={(date: any) => setDate(date, 'start')}
                      popperProps={{ strategy: 'fixed' }}
                    />
                  </>
                </div>
                <Form.Field required={true}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <>
                      <h4
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          paddingTop: '10px',
                          paddingLeft: '20px',
                        }}
                      >
                        To Date
                      </h4>
                      <DatePicker
                        placeholderText="To Date"
                        value={
                          endDate
                            ? PivotStore.dateFormat(
                                moment(endDate).format('MM-DD-YYYY'),
                              )
                            : ''
                        }
                        className="date-picker-style"
                        showMonthDropdown
                        showYearDropdown
                        locale={'en'}
                        dateFormatCalendar="MMMM"
                        yearDropdownItemNumber={15}
                        maxDate={moment().add(0, 'days').toDate()}
                        scrollableYearDropdown
                        onChange={(date: any) => setDate(date, 'end')}
                        popperProps={{ strategy: 'fixed' }}
                      />
                    </>
                  </div>
                </Form.Field>
                <Form.Field required={true}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <>
                      <h4
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          paddingTop: '10px',
                          paddingLeft: '20px',
                        }}
                      >
                        Location
                      </h4>
                      <Dropdown
                        style={{ margin : '0 30px 0 10px'}}
                        placeholder="Select Location"
                        fluid
                        selection
                        search
                        clearable
                        value={location.selected || ""}
                        options={location.options || []}
                        onChange={(_event, data) =>
                          setLocation((prev) => ({
                            ...prev,
                            selected: data.value as string,
                          }))
                        }
                      />
                    </>
                  </div>
                </Form.Field>
                <Form.Field>
                  <Button
                    primary
                    onClick={dateBasedDataLoad}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingRight: '20px',
                      paddingBottom: '10px',
                    }}
                  >
                    View Report
                  </Button>
                </Form.Field>
                {loadData.length !== 0 && (
                  <div style={{marginLeft: '10px'}}>
                    <DynamicTableCSVReport
                      tableData={loadData}
                      tableName='DefectReportNFAI'
                      name='DefectReportNFAI'
                      fileName={`StartDate_${startDate}_EndDate_${endDate}_DefectReport`}
                    />
                  </div>
                )}
              </>
            ) : null}
          </div>
        </div>
        <br />

        {tableLoading && (
          <div className="loader-container-defect">
            <div className="loader-defect"></div>
          </div>
        )}
        {tableEnable && !tableLoading && (
          <div className="table-wrapper">
            <Table className="ui fixed table">
              <Table.Header>
                <Table.Row>
                  {[
                    'Reject Date', 'Film Title', 'Resolution', 'A+M/Pristine', 'Operator Employee ID', 'Operator Name',
                    'Quality ID', 'Quality Name', 'Work Type', 'Start Frame', 'End Frame',
                    'Total Frame', 'Defect Type', 'Error Start Frame', 'Error End Frame',
                    'Error Total Frame', 'Position', 'Severity', 'location'
                  ].map((header, idx) => (
                    <Table.HeaderCell key={idx}>{header}</Table.HeaderCell>
                  ))}
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {loadData.map((data, index) => (
                  <Table.Row key={index}>
                    {[
                      data.reject_Date, data.film_Title, data.resolution, data.amPristine, 
                      data.operator_Employee_ID, data.operator_name, data.quality_ID, data.quality_name, 
                      data.work_Type, data.start_Frame, data.end_Frame, data.total_Frame, data.typeoferror, 
                      data.error_St_Frame, data.error_end_Frame, data.error_total_Frame, data.position, data.severity,
                      data.location
                    ].map((value, i) => (
                      <Table.Cell key={i} style={{ backgroundColor: i % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>{value}</Table.Cell>
                    ))}
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        )}
      </Segment>
    </div>
  );
};

export default observer(NFAIDefectReport);
